export var FIRST_NAME_REQUIRED = {
    message: 'Please enter a first name.',
};
export var FIRST_NAME_INVALID = {
    message: 'We only allow letters (a-z), numbers and the following symbols: &*#();-@/."',
};
export var LAST_NAME_REQUIRED = {
    message: 'Please enter a last name.',
};
export var LAST_NAME_INVALID = {
    message: 'We only allow letters (a-z), numbers and the following symbols: &*#();-@/."',
};
export var PHONE_REQUIRED = {
    message: 'Please provide a 10-digit phone number.',
};
export var PHONE_INVALID = {
    message: 'Not a valid phone number. Please enter a valid phone number',
};
export var PHONE_DUPLICATE = {
    message: 'Please provide a unique number. This is a duplicate of a preexisitng number.',
};
export var PHONE_NUMBER_ALREADY_REGISTERED_ERROR = {
    message: 'This phone number is registered with an existing Pro Xtra account.',
};
export var EMAIL_INVALID = {
    message: 'Please provide a valid email address.',
};
export var EMAIL_REQUIRED = {
    message: 'Please provide an email address.',
};
export var EMAIL_DUPLICATE = {
    message: 'This email already exists for a user on your account.',
};
export var USER_TYPE_REQUIRED = {
    message: 'Select one of the user types above.',
};
export var ZIPCODE_REQUIRED = {
    message: 'Please provide a 5-digit ZIP code.',
};
export var COMPANY_NAME_REQUIRED = {
    message: 'Please provide your company name.',
};
export var COMPANY_NAME_INVALID = {
    message: 'You’ve entered an invalid character. Try again using only letters (a-z), numbers, and the following symbols: &*#();-@/.',
};
export var COMPANY_ADDRESS_REQUIRED = {
    message: 'Please provide your company address.',
};
export var ADDRESS_REQUIRED = {
    message: 'Please provide your address.',
};
export var COMPANY_ADDRESS_INVALID = {
    message: 'Please enter a valid address line 1.',
};
export var COMPANY_ADDRESS_LINE_2_INVALID = {
    message: 'Please enter a valid address line 2.',
};
export var TRADE_REQUIRED = {
    message: 'Business or Trade required.',
};
export var OTHER_BUSINESS_REQUIRED = {
    message: 'Other Business or Trade required.',
};
export var OTP_REQUIRED = {
    message: 'Please provide a code.',
};
export var OTP_INVALID = {
    message: 'Please provide a valid code.',
};
export var FIELD_REQUIRED = {
    message: 'This field is required.',
};
export var BUSINESS_TYPE_REQUIRED = {
    message: 'Please provide your business type.',
};
export var EMAIL_REQUIRED_BULK_ADD = {
    message: 'Please provide an email address.',
};
export var EMAIL_INVALID_BULK_ADD = {
    message: 'Please enter a valid email.',
};
export var INVALID_FIELD_BULK_ADD = {
    message: 'We only allow letters (a-z), numbers and the following symbols: &*#();-@/."',
};
export var ROLE_REQUIRED_BULK_ADD = {
    message: 'Please select a role.',
};
export var FIRST_NAME_REQUIRED_BULK_ADD = {
    message: 'Please enter a first name.',
};
export var FILE_IS_REQUIRED = {
    message: 'Please upload a CSV file.',
};
export var getInvalidFileTypeMessage = function (fileName) {
    return "".concat(fileName, " is an invalid file type and cant be uploaded. Please upload a CSV file.");
};
export var LAST_NAME_REQUIRED_BULK_ADD = {
    message: 'Please enter a last name.',
};
export var ADD_USER_FIRST_NAME_REQUIRED = {
    message: 'Please enter a first name.',
};
export var ADD_USER_LAST_NAME_REQUIRED = {
    message: 'Please enter a last name.',
};
export var FIRST_NAME_TOO_LONG = {
    message: "First name can't be longer than 40 characters.",
};
export var LAST_NAME_TOO_LONG = {
    message: "Last name can't be longer than 60 characters.",
};
export var SELECTING_REASON_REQUIRED = {
    message: 'A reason is required.',
};
export var ACKNOWLEDGEMENT_REQUIRED = {
    message: 'Please acknowledge that you have read the information above by checking the box.',
};
export var RESEND_INVITE_USER_INVALID = {
    message: "We’re unable to resend this invite. Please check user's information",
};
